import { render, staticRenderFns } from "./ChangguanAreaStatBlock.vue?vue&type=template&id=32eb5e6c&scoped=true"
import script from "./ChangguanAreaStatBlock.vue?vue&type=script&lang=js"
export * from "./ChangguanAreaStatBlock.vue?vue&type=script&lang=js"
import style0 from "./ChangguanAreaStatBlock.vue?vue&type=style&index=0&id=32eb5e6c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32eb5e6c",
  null
  
)

export default component.exports